function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 
 * @file Helper for the box metadata query API
 * @author Box
 */
import Base from './Base';
import { CACHE_PREFIX_METADATA_QUERY, ERROR_CODE_METADATA_QUERY } from '../constants';

class MetadataQuery extends Base {
  constructor() {
    super(...arguments);

    _defineProperty(this, "queryMetadataSuccessHandler", (_ref) => {
      let {
        data
      } = _ref;
      const cache = this.getCache();
      cache.set(this.key, data);
      this.finish();
    });
  }

  /**
   * @property {string}
   */

  /**
   * @property {Function}
   */

  /**
   * @property {Function}
   */

  /**
   * Creates a key for the metadata cache
   *
   * @param {string} id - metadata template
   * @return {string} key
   */
  getCacheKey(id) {
    return "".concat(CACHE_PREFIX_METADATA_QUERY).concat(id);
  }
  /**
   * API URL for metadata query
   * @return {string} base url for files
   */


  getUrl() {
    return "".concat(this.getBaseApiUrl(), "/metadata_queries/execute_read");
  }
  /**
   * Returns true for cache hit for metadata query results
   *
   * @return {boolean} if query results are loaded
   */


  isLoaded() {
    const cache = this.getCache();
    return cache.has(this.key);
  }
  /**
   * Returns the results using successCallback
   *
   * @return {void}
   */


  finish() {
    if (this.isDestroyed()) {
      return;
    }

    const cache = this.getCache();
    const metadataQueryData = cache.get(this.key);
    this.successCallback(metadataQueryData);
  }
  /**
   * @param {Object} response
   */


  /**
   * Does the network request to metadata query API
   * @param {Object} query query object with SQL Clauses like properties
   * @return {void}
   */
  queryMetadataRequest(query) {
    if (this.isDestroyed()) {
      return;
    }

    this.errorCode = ERROR_CODE_METADATA_QUERY;
    this.xhr.post({
      url: this.getUrl(),
      data: query
    }).then(this.queryMetadataSuccessHandler).catch(this.errorHandler);
  }
  /**
   * API for querying enterprise metadata
   * @param {Object} query - metadata query object
   * @param {Function} successCallback - Function to call with results
   * @param {Function} errorCallback - Function to call with errors
   * @param {boolean|void} [options.forceFetch] - Bypasses the cache
   * @return {void}
   */


  queryMetadata(query, successCallback, errorCallback) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    if (this.isDestroyed()) {
      return;
    }

    const {
      context = {}
    } = options;
    this.key = this.getCacheKey(context.id);
    this.successCallback = successCallback;
    this.errorCallback = errorCallback; // Clear the cache if needed

    if (options.forceFetch) {
      this.getCache().unset(this.key);
    } // Return the Cache value if it exists


    if (this.isLoaded()) {
      this.finish();
      return;
    } // Make the XHR request


    this.queryMetadataRequest(query);
  }

}

export default MetadataQuery;
//# sourceMappingURL=MetadataQuery.js.map